import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import { PageInfoFragmentDoc } from '../../../graphql/fragments/PageInfo.generated';
import type * as GraphQLTypes from '../../../graphql/types.generated';
const defaultOptions = {} as const;

export type TerminalsQueryVariables = GraphQLTypes.Exact<{
  after?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  before?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  first?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Int']['input']>;
  last?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Int']['input']>;
  query?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
}>;

export type TerminalsQueryResult = { __typename?: 'Query' } & {
  transportTerminals?: GraphQLTypes.Maybe<
    { __typename?: 'TransportTerminalConnection' } & Pick<GraphQLTypes.TransportTerminalConnection, 'totalCount'> & {
        nodes?: GraphQLTypes.Maybe<
          Array<
            { __typename?: 'TransportTerminal' } & Pick<GraphQLTypes.TransportTerminal, 'id' | 'label'> & {
                unlocode: GraphQLTypes.TransportTerminal['code'];
              }
          >
        >;
        pageInfo: { __typename: 'PageInfo' } & Pick<
          GraphQLTypes.PageInfo,
          'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'
        >;
      }
  >;
};

export const TerminalsDocument = /*#__PURE__*/ gql`
  query terminals($after: String, $before: String, $first: Int, $last: Int, $query: String) {
    transportTerminals(after: $after, before: $before, first: $first, last: $last, query: $query) {
      nodes {
        id
        label
        unlocode: code
      }
      pageInfo {
        ...PageInfo
      }
      totalCount
    }
  }
  ${PageInfoFragmentDoc}
`;

/**
 * __useTerminalsQuery__
 *
 * To run a query within a React component, call `useTerminalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTerminalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTerminalsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useTerminalsQuery(baseOptions?: Apollo.QueryHookOptions<TerminalsQueryResult, TerminalsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<TerminalsQueryResult, TerminalsQueryVariables>(TerminalsDocument, options);
}
export function useTerminalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TerminalsQueryResult, TerminalsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<TerminalsQueryResult, TerminalsQueryVariables>(TerminalsDocument, options);
}
export type TerminalsQueryHookResult = ReturnType<typeof useTerminalsQuery>;
export type TerminalsLazyQueryHookResult = ReturnType<typeof useTerminalsLazyQuery>;
